<template>
  <div class="footer">
    <div class="container">
      <div class="top">
        <el-row>
          <el-col :xs="24" :sm="24" :lg="16" :xl="18">
            <div class="textContent">
              <p>联系方式：0371-6358-7917</p>
              <p>地　　址：郑州市惠济区清华园路28号</p>
              <p>版权所有：河南省新闻出版学校　豫ICP备20000000号-1</p>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :lg="8" :xl="6">
            <div class="applet">
              <span>扫一扫，打开小程序　　</span>
              <img src="./images/code.png" alt="二维码" class="code" />
            </div>
          </el-col>
        </el-row>

      </div>
      <div class="bottom"></div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.footer {
  max-width: 1920px;
  overflow: hidden;
  margin: 0 auto;

  .container {
    max-width: 1920px;
    // height: 274px;

    .top {
      max-width: 1400px;
      margin: 0 auto;
      // height: 246px;
      background: #fff;
      position: relative;
      font-size: 18px;

      .textContent {
        // position: absolute;
        // top: 62px;
        // left: 262px;

        font-family: Microsoft YaHei;
        float: left;

        & p {
          height: 33px;
          color: #454545;
          line-height: 48px;
          margin-bottom: 10px;
          font-weight: 400;
        }

        & p:last-child {
          color: #454545;
          line-height: 48px;
        }
      }

      .applet {
        position: relative;
        height: 246px;

        span {
          height: 19px;
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #454545;
          // position: absolute;
          // right: 416px;
          // top: 110px;
          display: inline-block;
          line-height: 246px;
          text-align: left;
        }

        .code {
          width: 114px;
          height: 114px;
          // margin-top: 20%;
          position: absolute;
          top: 63px;
          //   right: 280px;
        }
      }

    }

    .bottom {
      max-width: 1920px;
      height: 41px;
      background: #fd412f;
    }
  }
}
</style>
